module.exports = __webpack_public_path__ + "static/assets/f291bb5d3a5731f26512279f6b97b50d.svg";